import { render, staticRenderFns } from "./TicketsUser.vue?vue&type=template&id=2cf591ca&"
import script from "./TicketsUser.vue?vue&type=script&lang=js&"
export * from "./TicketsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports